// Module
var code = "<div class=\"c-datatable-drillableCell u-sizeFullWidth ui-grid-cell-contents\">\n     <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n          <a ng-bind=\"row.entity.dateTime\" ng-click=\"grid.appScope.$ctrl.openAdditionalUsageDetailsPopup(row.entity)\">\n          </a>\n      </div>\n</div>\n";
// Exports
module.exports = code;